const colors = {
  open: "#0B51C4",
  pending: "#C4790B",
  approved: "#0BC46E",
  rejected: "#D3354A"
};

export default colors;
